// useCreatePartyModal.ts
import { BlockedUser } from '@models/blocked-user.model';
import { LOADING, SUCCESSFUL } from '@models/status';
import { addGames, removeGame, setGames, setLoading, updateGame } from '@redux/reducers/ongoing-game-reducer';
import { removeGames } from '@redux/reducers/pending-game-reducer';
import { RootState } from '@redux/store';
import { d } from '@utils/encryption-wrapper';
import { Party } from 'interfaces/party.interface';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

export const useOngoingGame = () => {
    const { blocked_gamers } = useSelector((state: RootState) => state.blockGamerStore);
    const dispatch = useDispatch();

    const onOngoingGameUpdate = (partUpdateData: string) => {
        const partUpdate: Party = d(partUpdateData);
        dispatch(updateGame(partUpdate));
    };

    const onOngoingGameAdd = (partListData: string) => {
        const partList: Party[] = d(partListData);
        dispatch(removeGames(partList.map((party) => party.id)));
        _setPartListData(partList);
    };

    const onOngoingGameExit = (partIdData: string) => {
        const partId: string = d(partIdData);
        dispatch(removeGame(partId));
    };

    const setPartListData = (games: Party[]) => {
        dispatch(addGames(games));
    };

    const _setPartListData = (partList: Party[]) => {
        const newStatePartList = partList.filter((part) => {
            return (
                part.bet === 0 ||
                part.max_nb_players === 1 ||
                !blocked_gamers.some((el: BlockedUser) => el.id === part.creator_id)
            );
        });
        setPartListData(newStatePartList);
    };

    const onOngoingGameSocketDisconnect = () => {
        dispatch(setGames([]));
        dispatch(setLoading(LOADING));
    };

    const onOngoingGameSocketReconnect = () => {
        dispatch(setLoading(SUCCESSFUL));
    };

    const onGetOngoingGames = (data: string) => {
        const partyList: Party[] = d(data);
        dispatch(setGames(partyList));
    };

    return {
        onOngoingGameUpdate,
        onOngoingGameAdd,
        onOngoingGameExit,
        onOngoingGameSocketDisconnect,
        onOngoingGameSocketReconnect,
        onGetOngoingGames,
    };
};
